import Timbers from "../../images/timbers.png"
import Glases from "../../images/glasess.png"
import Sandle from "../../images/sandle.png"
import Watches from "../../images/watch.png"

const ItemsRelatedResult = [
    {id: 1, image: Sandle, Email: 'Sandle.com' , Price: '30$' , image_link: 'twitter'},
    {id: 2, image: Watches, Email: 'Vision.com' , Price: '10$' , image_link: 'twitter'},
    {id: 3, image: Timbers, Email: 'Timbers.com' , Price: '5$' , image_link: 'twitter'},
    {id: 4, image: Glases, Email: 'Glases.com' , Price: '10%' , image_link: 'twitter'},
]
export default ItemsRelatedResult